var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-render-text-color"},[_c('span',{style:({color:this.params.value.color, fontWeight:'600'})},[_vm._v(_vm._s(_vm.params.value.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }